import styled from "styled-components";
import HipShipGreen from "../assests/logo/hipShipGreen.png";
import HipShipDash from "../assests/hipship-dash.png";
import HipShipLogin from "../assests/hipship-login.png";
import HipShipThree from "../assests/hipship3.png";
import HipShipFour from "../assests/hipship4.png";
import HipShipFive from "../assests/hipship5.png";
import { Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Tilt } from "react-tilt";

const defaultOptions = {
  reverse: false, // reverse the tilt direction
  max: 15, // max tilt rotation (degrees)
  perspective: 1000, // Transform perspective, the lower the more extreme the tilt gets.
  scale: 1.1, // 2 = 200%, 1.5 = 150%, etc..
  speed: 1000, // Speed of the enter/exit transition
  transition: true, // Set a transition on enter/exit.
  axis: null, // What axis should be disabled. Can be X or Y.
  reset: true, // If the tilt effect has to be reset on exit.
  easing: "cubic-bezier(.03,.98,.52,.99)",
};

const StyledTopBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100px;
  width: 100%;
`;

const ImageContainer = styled.div`
  width: 120px;
  > img {
    width: 100%;
    height: 100%;
  }
`;

const DashboardImageContainer = styled.div`
  width: 600px;
  height: 100%;
  position: relative;

  > div {
    height: 100%;
  }

  > div div {
    position: absolute;
    width: 100%;
    top: 20%;

    > .show {
      opacity: 1;
    }

    > .hide {
      opacity: 0;
    }
  }

  > div img {
    transition: all ease-in-out 0.3s;
    width: 100%;
    border-radius: 10px;
    box-shadow: #15151568 0px 3px 10px;
  }
`;

const LandingPage = () => {
  const navigate = useNavigate();

  const [show, setShow] = useState(["show", "hide", "hide", "hide", "hide"]);

  useEffect(() => {
    let index = 1;
    const changeImage = () => {
      let newArray = ["hide", "hide", "hide", "hide", "hide"];
      newArray[index] = "show";
      setShow(newArray);
      if (index !== 4) {
        index++;
      } else {
        index = 0;
      }
    };

    const intervalId = setInterval(changeImage, 3000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        overflow: "hidden",
        backgroundColor: "#f5f7fa",
        padding: "100px",
      }}
    >
      <StyledTopBar>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          margin={"0 100px"}
          height={"100%"}
        >
          <ImageContainer>
            <img src={HipShipGreen} alt="logo" />
          </ImageContainer>
          <div>
            <Button
              sx={{
                textTransform: "none",
              }}
              variant="contained"
              onClick={() => navigate("/login")}
            >
              Login
            </Button>
          </div>
        </Stack>
      </StyledTopBar>

      <Stack
        direction={"row"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={"100px"}
        height={"100%"}
      >
        <Stack
          justifyContent={"flex-start"}
          alignItems={"flex-start"}
          rowGap={"20px"}
        >
          <Typography fontSize={"26px"}>
            Cloud-based platform to manage and ship your orders.
          </Typography>
          <Button
            sx={{
              textTransform: "none",
            }}
            variant="contained"
            onClick={() => navigate("/register")}
          >
            Sign-up Now
          </Button>
        </Stack>
        <div
          style={{
            height: "100%",
          }}
        >
          <DashboardImageContainer>
            <Tilt options={defaultOptions}>
              <div>
                <img className={show[0]} src={HipShipDash} alt="dashboard" />
              </div>
              <div>
                <img className={show[1]} src={HipShipLogin} alt="dashboard" />
              </div>
              <div>
                <img className={show[2]} src={HipShipThree} alt="dashboard" />
              </div>
              <div>
                <img className={show[3]} src={HipShipFour} alt="dashboard" />
              </div>
              <div>
                <img className={show[4]} src={HipShipFive} alt="dashboard" />
              </div>
            </Tilt>
          </DashboardImageContainer>
        </div>
      </Stack>
    </div>
  );
};

export default LandingPage;
